import React from 'react';
import {
  Row, Col,
} from 'reactstrap';


export default function ProfileInfo(props) {
  const {
    name,
    father,
    mother,
    position,
    role
  } = props.profile;
  return (
    <Row>
      <Col>
        <Row className="pt-4">
          <Col>
            <p className="mb-1">{father}, {mother}의 {position}</p>
            <h4>{role} {name}</h4>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
